<template>
    <v-app>
        <product-type-setup :dialog="productTypeDialog" :data="data" @update:dialog="productTypeDialog = $event" />  
        <category-setup :dialog="categoryDialog" :data="data" @update:dialog="categoryDialog = $event" />  
        <sub-category-setup :dialog="subCategoryDialog" :data="data" @update:dialog="subCategoryDialog = $event" />  
        <size-setup :dialog="sizeDialog" :data="data" @update:dialog="sizeDialog = $event" />  
        <color-setup :dialog="colorDialog" :data="data" @update:dialog="colorDialog = $event" />  
        <brand-setup :dialog="brandDialog" :data="data" @update:dialog="brandDialog = $event" />  
        <unit-setup :dialog="unitDialog" :data="data" @update:dialog="unitDialog = $event" />
        <secondary-unit-setup :dialog="secUnitDialog"  :data="data" @update:dialog="secUnitDialog = $event " />
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" >
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header"><span>{{ isEntryMode ? "Add Product" : "Update Product" }}</span></v-expansion-panel-title>
                                    <v-expansion-panel-text> 
                                            <v-row class="py-2 no-gutters justify-space-around">
                                                <v-col lg="4" md="4" cols="12">

                                                    <v-text-field
                                                        label="Product Code"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="code.value.value"
                                                        :error-messages="code.errorMessage.value"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Product Code
                                                        </template>
                                                    </v-text-field>

                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="type_id.value.value"
                                                        :error-messages="type_id.errorMessage.value"
                                                        clearable
                                                        :items="getProductTypeList"
                                                        :item-title="item => `${item.code} - ${item.name}`"   
                                                        autocomplete="off"                                               
                                                        item-value="id"
                                                        @update:modelValue="getProductTypeList"
                                                    >
                                                        <template #label>
                                                            Product Type <span class="text-red-accent-4">*</span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddProductType"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>
                                                    
                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="category_id.value.value"
                                                        :error-messages="category_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"        
                                                        :items="getCategoryList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getCategoryList" 
                                                    >  
                                                        <template #label>
                                                            Category <span class="text-red-accent-4">*</span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddCategory"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="subcategory_id.value.value"
                                                        :error-messages="subcategory_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"        
                                                        :items="getSubCategoryList.filter(item => item.category_id == category_id.value.value)"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getSubCategoryList" 
                                                    >   
                                                        <template #label>
                                                            Sub Category<span class="text-red-accent-4"></span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddSubCategory"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-text-field
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="name.value.value"
                                                        :error-messages="name.errorMessage.value"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Product Name <span class="text-red-accent-4">*</span>
                                                        </template>
                                                    </v-text-field>

                                                    <v-text-field
                                                        label="Model"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="model.value.value"
                                                        :error-messages="model.errorMessage.value"
                                                        clearable
                                                    >
                                                    </v-text-field>

                                                    <v-text-field
                                                        label="Bar Code"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="barcode.value.value"
                                                        :error-messages="barcode.errorMessage.value"
                                                        clearable
                                                    >
                                                    </v-text-field>

                                                    <v-text-field
                                                        label="Stock Alert Quantity"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="stockAlertQuantity.value.value"
                                                        :error-messages="stockAlertQuantity.errorMessage.value"
                                                        clearable
                                                    >
                                                    </v-text-field>
                                                </v-col>

                                                <v-col lg="4" md="4" cols="12">

                                                    <v-autocomplete
                                                        label="Size"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="size_id.value.value"
                                                        :error-messages="size_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"        
                                                        :items="getSizeList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getSizeList" 
                                                    > 
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddSize"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="unit_id.value.value"
                                                        :error-messages="unit_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"
                                                        :items="getUnitList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getUnitList" 
                                                    >   

                                                        <template #label>
                                                            Unit <span class="text-red-accent-4">*</span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddUnit"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="secondary_unit_id.value.value"
                                                        :error-messages="secondary_unit_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"
                                                        :items="getSecondaryUnitList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getSecondaryUnitList" 
                                                    >   

                                                        <template #label>
                                                          Secondary  Unit <span class="text-red-accent-4"></span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddSecUnit"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete
                                                        label="Color"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="color_id.value.value"
                                                        :error-messages="color_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"
                                                        :items="getColorList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        @update:modelValue="getColorList" 
                                                    >   
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                @mousedown.stop="openAddColor"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>
                                                    
                                                    <v-autocomplete
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="brand_id.value.value"
                                                        :error-messages="brand_id.errorMessage.value"
                                                        clearable
                                                        autocomplete="off"        
                                                        :items="getBrandList"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                 
                                                        item-value="id"
                                                        @update:modelValue="getBrandList" 
                                                    >   

                                                        <template #label>
                                                            Brand <span class="text-red-accent-4"></span>
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-slide-x-reverse-transition mode="out-in">
                                                                <v-icon
                                                                :key="`icon-${1}`"
                                                                @mousedown.stop="openAddBrand"
                                                                icon="mdi-plus-circle-outline"
                                                                color="primary"
                                                                size="24"
                                                                class="cursor-pointer"
                                                                ></v-icon>
                                                            </v-slide-x-reverse-transition>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-text-field
                                                        label="Weight"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        type="number"
                                                        :min="0"
                                                        v-model="weight.value.value"
                                                        :error-messages="weight.errorMessage.value"
                                                        clearable
                                                    >
                                                    </v-text-field>


                                                    <v-text-field
                                                        label="Lot No "
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="art_no.value.value"
                                                        :error-messages="art_no.errorMessage.value"
                                                        clearable
                                                    ></v-text-field>

                                                </v-col>
                                                <v-col lg="4" md="4" cols="12">
                                                      <v-text-field
                                                        label="Tax"
                                                        type="number"
                                                        :min="0"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="tax.value.value"
                                                        :error-messages="tax.errorMessage.value"
                                                        clearable
                                                    ></v-text-field>


                                                    <v-text-field   
                                                        type="number"
                                                        :min="0"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="purchase_rate.value.value"
                                                        :error-messages="purchase_rate.errorMessage.value"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Purchase Rate <span class="text-red-accent-4"></span>
                                                        </template>
                                                    </v-text-field>

                                                    <v-text-field
                                                        type="number"
                                                        :min="0"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="sale_rate.value.value"
                                                        :error-messages="sale_rate.errorMessage.value"
                                                        clearable
                                                    >
                                                        <template #label>
                                                            Sale Rate <span class="text-red-accent-4"></span>
                                                        </template>
                                                    </v-text-field> 

                                                     <v-text-field
                                                        type="number"
                                                        :min="0"
                                                        label="Salvage Value"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="salvage_value.value.value"
                                                        :error-messages="salvage_value.errorMessage.value"
                                                        clearable
                                                    ></v-text-field>
                                                
                                                    <v-textarea
                                                        clear-icon="mdi-close-circle"
                                                        rows="3"
                                                        maxlength="500"
                                                        label="Description"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        class="px-2"
                                                        v-model="description.value.value"
                                                        :error-messages="description.errorMessage.value"
                                                        clearable
                                                    ></v-textarea>

                                                    <v-file-input
                                                        v-model="selectedImage"
                                                        label="Product Image"
                                                        accept="image/*"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        persistent-hint
                                                        hint="Image must be exactly 120px × 120px"
                                                        show-size
                                                        @input="previewImage"                               
                                                        @click:clear="clearImage"
                                                        prepend-icon="mdi-camera"
                                                        class="ellipsis-filename px-2"
                                                        title="image"
                                                    >                                                                                                  
                                                    </v-file-input>

                                                    <div class="px-2" style="float: right;">
                                                        <v-img :src="preview" cover  class="preview-image"></v-img>
                                                    </div>

                                                    <v-checkbox                            
                                                        label="Active"
                                                        v-model="status.value.value"
                                                        :error-messages="status.errorMessage.value"
                                                        density="compact"
                                                        variant="outlined"
                                                        hide-details
                                                        color="primary"
                                                        class="px-2"
                                                    ></v-checkbox>
                                                    <input v-model="product_id.value.value" type="hidden">

                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>
                                                <v-card-actions>
                                                    <v-layout class="justify-end">
                                                            <v-btn 
                                                            class="bg-brand w-15 ms-2"  
                                                            variant="flat" 
                                                            type="submit"
                                                            >
                                                            {{ isEntryMode ? 'Save' : 'Update' }}
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-card-actions>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
            </v-container>
        </v-app>
</template>

<script>

import productTypeSetup from '@/components/module/inventory/settingsManagement/productTypeSetup.vue';
import categorySetup from '@/components/module/inventory/settingsManagement/categorySetup.vue';
import subCategorySetup from '@/components/module/inventory/settingsManagement/subCategorySetup.vue';
import sizeSetup from '@/components/module/inventory/settingsManagement/sizeSetup.vue';
import unitSetup from '@/components/module/inventory/settingsManagement/unitSetup.vue';
import secondaryUnitSetup from '@/components/module/inventory/settingsManagement/secondaryUnitSetup.vue';
import colorSetup from '@/components/module/inventory/settingsManagement/colorSetup.vue';
import brandSetup from '@/components/module/inventory/settingsManagement/brandSetup.vue';
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 
import { fileServerUrl } from "@/store/api";

const DEFAULT_IMAGE = '/src/assets/no_preview.jpeg';

export default {
        components: {
            productTypeSetup,
            categorySetup,
            subCategorySetup,
            sizeSetup,
            colorSetup,
            brandSetup,
            unitSetup,
            secondaryUnitSetup,
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            productTypeDialog: false,
            categoryDialog: false,
            subCategoryDialog: false, 
            sizeDialog: false,
            colorDialog: false,
            brandDialog: false,
            isEntryMode: true,  
            unitDialog: false,
            secUnitDialog: false,
            data: {},
            preview: '/src/assets/no_preview.jpeg',
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "user_code", align: "left", sortable: false },
                { title: "Name", key: "name", align: "left", sortable: false },
                { title: "Mobile", align: "left", key: "mobile", sortable: true },
                { title: "Email", align: "left", key: "email", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {

        },
        created(){
            if(this.$store.getters.getProductTypeList.length == 0){
                this.loading = true;
                this.$store.dispatch('getProductTypeList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getCategoryList.length == 0){
                this.loading = true;
                this.$store.dispatch('getCategoryList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getSubCategoryList.length == 0){
                this.loading = true;
                this.$store.dispatch('getSubCategoryList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getSizeList.length == 0){
                this.loading = true;
                this.$store.dispatch('getSizeList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getUnitList.length == 0){
                this.loading = true;
                this.$store.dispatch('getUnitList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getSecondaryUnitList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getSecondaryUnitList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getColorList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getColorList').then((response) => {
                    this.loading = false;
                })
            };
            if(this.$store.getters.getBrandList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getBrandList').then((response) => {
                    this.loading = false;
                })
            };
        },
        computed:{
            getProductTypeList(){
                let data = this.$store.getters.getProductTypeList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getCategoryList(){
                let data = this.$store.getters.getCategoryList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getSubCategoryList(){
                let data = this.$store.getters.getSubCategoryList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getSizeList(){
                let data = this.$store.getters.getSizeList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getUnitList(){
                let data = this.$store.getters.getUnitList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getSecondaryUnitList(){
                let data = this.$store.getters.getSecondaryUnitList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getColorList(){
                let data = this.$store.getters.getColorList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            getBrandList(){
                let data = this.$store.getters.getBrandList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            },
            editingProduct() {
                return this.$store.getters.getEditingProduct;
            }
        },
        methods: {
            openAddProductType() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.productTypeDialog = true;
            },
            openAddCategory() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.categoryDialog = true;
            },
            openAddSubCategory() {
                this.data = {
                    id: '',
                    category_id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.subCategoryDialog = true;
            },
            openAddUnit() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.unitDialog = true;
            },
            openAddSecUnit() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.secUnitDialog = true;
            },
            openAddSize() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.sizeDialog = true;
            },
            openAddColor() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.colorDialog = true;
            },
            openAddBrand() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.brandDialog = true;
            },  

            closeDialog() {
                this.dialog = false;
                this.productTypeDialog = false;
                this.categoryDialog = false;
                this.subCategoryDialog = false;
                this.sizeDialog = false;
                this.unitDialog = false;
                this.secUnitDialog = false;
                this.colorDialog = false;
                this.brandDialog = false;
                this.data = {};
            },
            resetForm() {
                this.data = {};
                this.preview = '/src/assets/no_preview.jpeg';
                this.selectedImage = null;
            },
            previewImage: function(event) {
                this.selectedImage = event.target.files[0];
                const input = event.target;
                if (input.files && input.files[0]) {
                        var reader = new FileReader();
                        reader.onload = (e) => {
                        this.preview = e.target.result;
                    }
                    this.image = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
                else {
                    this.preview = '/src/assets/no_preview.jpeg';
                }
            },
            clearImage() {
                this.preview = '/src/assets/no_preview.jpeg';
            },
        },

        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    type_id: yup.number().positive().integer().required().label('Product Type Name'),
                    category_id: yup.number().positive().integer().required().label('Category Name'),       
                    subcategory_id: yup.number().positive().nullable().label('Sub Category Name'),       
                    name: yup.string().min(1).max(255).required().trim().label('Product Name'),
                    //code: yup.string().required().min(1).max(50).label('Product Code'),
                    unit_id: yup.number().positive().integer().required().label('Unit'),
                    purchase_rate: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).nullable().max(99999999.99).label('Purchase Rate'),   
                    sale_rate: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).nullable().max(99999999.99).label('Sale Rate'),
                    salvage_value: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).nullable().max(99999999.99).label('Salvage Value'),
                    secondary_unit_id: yup.number().positive().nullable().label('Secondary Unit'),
                    brand_id: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).positive().integer().nullable().label('Brand'),
                    art_no: yup.string().nullable().min(1).max(100).label('Art No'),
                    description: yup.string().nullable().max(500).label('Description'),
                    size_id: yup.number().positive().integer().nullable().label('Size'),
                    color_id: yup.number().positive().integer().nullable().label('Color'),
                    weight: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).positive().nullable().min(0).max(99999.999).label('Weight'),
                    tax: yup.number().transform((value, orgVal) => orgVal === '' ? null : value).positive().nullable().min(0).max(99999.99).label('Tax'),         
                    barcode: yup.string().nullable().min(1).max(100).label('Bar Code'),
                    stock_alert_quantity: yup.number().transform((value, orgVal) => orgVal === '' ? 0 : value).nullable().min(0).max(99999999).label('Stock Alert Quantity'),
                    remarks: yup.string().min(1).max(250).nullable().trim().label('Remark'),
                    model: yup.string().nullable().min(1).max(100).label('Model'),
                }),
            });

            const type_id = useField('type_id');
            const category_id = useField('category_id');
            const subcategory_id = useField('subcategory_id');

            const name = useField('name');
            const remarks = useField('remarks');
            const model = useField('model');
            const barcode = useField('barcode');
            const code = useField('code');
            const art_no = useField('art_no');
            const purchase_rate = useField('purchase_rate');
            const sale_rate = useField('sale_rate');
            const salvage_value = useField('salvage_value');
            const description = useField('description');
            const size_id = useField('size_id');    
            const unit_id = useField('unit_id');
            const secondary_unit_id = useField("secondary_unit_id");;
            const color_id = useField('color_id');
            const brand_id = useField('brand_id');
            const weight = useField('weight'); 
            const tax = useField('tax');
            const stockAlertQuantity = useField('stock_alert_quantity');
            const status = useField('status');
            const product_id = useField('product_id');
            
            const errorMessages  = ref('');
            const loading  = ref('');
            const selectedImage  = ref(null);
            const preview = ref(DEFAULT_IMAGE);
            const isEntryMode = ref(true);

            const store = useStore();
            const router = useRouter();
            const submit = handleSubmit((values) => { 
                // Create a FormData object
                const formData = new FormData();

                // Append all form values to FormData
                Object.keys(values).forEach((key) => {
                    if (key === 'stock_alert_quantity') {
                        const v = values[key];
                        formData.append(key, (v === '' || v === null || v === undefined) ? 0 : v);
                    } else {
                        formData.append(key, values[key] || "");
                    }
                });

                // Append the selected image to FormData
                if (selectedImage.value) {
                    formData.append('image', selectedImage.value); // 'image' is the key for the file
                }

                store.dispatch("saveUpdateProduct", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }) 
                    .then((response) => {  
                        resetForm();
                        loading.value = false;
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        setTimeout(() => {
                            router.push({ name: "product-list" });
                        }, 2000);
                    })
                    .catch((error) => { 
                        loading.value = false;
                        toast.error(error.response.data.message);      
                    })
            })
            return {
            submit,
            stockAlertQuantity,
            type_id,
            category_id,
            subcategory_id,
            name,
            remarks,
            model,
            barcode,
            code,
            art_no,
            purchase_rate,
            sale_rate,
            description,
            salvage_value,
            size_id,
            unit_id,
            secondary_unit_id,
            color_id,
            brand_id,
            weight,
            tax,
            status,
            errorMessages,
            selectedImage,
            preview,
            isEntryMode,
            product_id,
            resetForm,
            loading
            }
        },
        mounted() {
            const queryId = this.$route.query.id;
            if (this.$store.getters.getEditingProduct && queryId) {
                this.$store.commit('SET_LOADING', { color: 'primary' });
                
                this.isEntryMode = false;
                const product = this.$store.getters.getEditingProduct;
                this.product_id.value.value = product.id;
                this.type_id.value.value = product.type_id;
                this.category_id.value.value = product.category_id;
                this.subcategory_id.value.value = product.subcategory_id;
                this.name.value.value = product.name;
                this.remarks.value.value = product.remarks;
                this.model.value.value = product.model;
                this.barcode.value.value = product.barcode;
                this.code.value.value = product.code;
                this.art_no.value.value = product.art_no;
                this.purchase_rate.value.value = product.purchase_rate;
                this.sale_rate.value.value = product.sale_rate;
                this.description.value.value = product.description;
                this.salvage_value.value.value = product.salvage_value;
                this.size_id.value.value = product.size_id;    
                this.unit_id.value.value = product.unit_id;
                this.secondary_unit_id.value.value = product.secondary_unit_id;
                this.color_id.value.value = product.color_id;
                this.brand_id.value.value = product.brand_id;
                this.weight.value.value = product.weight; 
                this.tax.value.value = product.tax; 
                this.status.value.value = product.status == 1 ? true : false; 
                if (product.image) {
                    this.preview = product.image ? fileServerUrl + product.image : '/src/assets/no_preview.png';
                } else {
                    this.preview = DEFAULT_IMAGE;
                }


                this.$store.commit('UNSET_LOADING');
            } else {
                this.$store.commit("setEditingProduct", null);
                this.resetForm();
                this.product_id.value.value = '';
                this.purchase_rate.value.value = 0;
                this.sale_rate.value.value = 0;
                this.salvage_value.value.value = 0;
                this.status.value.value = true;  // Add this line to keep Active checkbox selected by default
                this.isEntryMode = true;    
              
            }
        },
        beforeUnmount() {
        // Clear the editing customer from Vuex when component is destroyed
        this.$store.commit('clearEditingProduct');
      }
    }
</script>